import { Routes as RouteDefinitions, TRoute } from 'config/routes';

type RouteMap = Record<string, TRoute>;

type InternalRoute = TRoute & {
  key: string;
  sorting: number;
};

type InternalRouteMap = Record<string, InternalRoute>;

type RouteArgs = Record<string, string | number | undefined>;

class LinkHandler {
  private _routes: InternalRouteMap = {};

  constructor() {
    const routes: InternalRoute[] = [];

    Object.keys(RouteDefinitions).forEach((routeKey, index) => {
      const route = (RouteDefinitions as RouteMap)[routeKey];

      routes.push({
        key: routeKey,
        ...route,
        sorting: route?.sorting ?? 100 + index,
      });
    });

    this._routes = routes
      .sort((a, b) => a.sorting - b.sorting)
      .reduce<InternalRouteMap>((acc, route) => {
        acc[route.key] = route;
        return acc;
      }, {});
  }

  get(routeKey: string, args: RouteArgs = {}): string {
    const route = this._routes[routeKey];

    if (!route) {
      return routeKey;
    }

    return this.getUrlWithArguments(route.path, args);
  }

  getRoute(routeKey: string): InternalRoute | null {
    return this._routes?.[routeKey] || null;
  }

  getAll(): InternalRouteMap {
    return this._routes;
  }

  getUrlWithArguments(path: string, args: RouteArgs = {}): string {
    let _path = path || '';

    for (const key in args) {
      const value = args[key];

      if (_path.match(`:${key}`)) {
        _path = _path.replace(`:${key}?`, `:${key}`).replace(`:${key}`, `${value ?? ''}`);
      }
    }

    return _path;
  }
}

export const linkHandler = new LinkHandler();
